import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  containerStyle: { margin: 0 },
  heightCommon: {
    maxHeight: '80%',
    minHeight: '50%',
  },
  modalParent: containerStyle => ({
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    //  margin: 10,
    ...containerStyle,
  }),
});

export default styles;
